<!-- 接收数据data和回调函数getFormCont() getFormPicker-->
<template>
  <div class="form">
    <!-- <van-form @submit="onSubmit">
            <div v-for='(item,key) in data' :key='key'>
                <van-field  :label="item.label" @click='item.url?$router.push(item.url):""'
                :value="item.value" readonly input-align="right" class="clickPush" :right-icon="item.url?'arrow':''"/>
                {{item.url}}
            </div>
        </van-form> -->
    <div v-for="(item, key) in data" :key="key" class="dome" v-show="!item.hidden">
      <!-- textarea -->
      <div class="formItem" v-if="item.edit">
        <!-- <van-field :required="item.required===2?true:false" v-model="item.value" rows="2" autosize :label="item.label" type="textarea" maxlength="200" placeholder="请输入..." show-word-limit @input="change(item.value)" /> -->
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <div class="formItemRight">
          <textarea v-model="item.value" maxlength="200" placeholder="请输入..."  @input="change(item.value)"/>
        </div>
      </div>
      <!-- 头像图片 -->
      <div class="formItem" v-else-if="item.img" @click="item.url ? $router.push(item.url) : ''">
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <div class="formItemRight">
          <img src="../../assets/ic_arrow_down_graay.png" class="formItemRightImg" />
          <img :src="item.value?utils.getFileUrl(Number(item.value)):defaultImg" class="formItemRightTX" />
        </div>
      </div>
      <!-- 弹出级联选择器框 -->
      <div class="formItem" v-else-if="item.picker" @click="$emit('getFormPicker', item.picker)">
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <div class="formItemRight">
          <img src="../../assets/ic_arrow_down_graay.png" class="formItemRightImg" />
          <span>{{ item.value }}</span>
        </div>
      </div>
      <!-- 普通文本展示（后面带百分号的） -->
      <div class="formItem" v-else-if="item.input">
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <div class="formItemRight">
          <p class="formItemRightTXB" style="display: inline-block">%</p>
          <input type="text" v-model="item.value" :disabled="item.disabled" />
        </div>
      </div>
      <!-- 图片展示 -->
      <div class="formItem" v-else-if="item.picture">
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <div class="picture">
          <div v-for="(cont, key) in item.pictureUrl" :key="key + 'picture'">
            <img :src="cont.url" />
            <span v-if="cont.title">{{ cont.title }}</span>
          </div>
        </div>
      </div>
      <!-- 普通文本编辑 -->
      <div class="formItem" v-else-if="item.field">
        <!-- <van-cell-group style="width: 100%">
          <van-field :required="item.required===2?true:false" v-model="item.value" :label="item.label" input-align="right" @input="input(item.value)" />
        </van-cell-group> -->
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <div class="formItemRight">
          <input type="text" v-model="item.value"  @input="input(item.value)"/>
        </div>
      </div>
      <!-- 普通文本展示 -->
      <div class="formItem" v-else-if="item.btns" >
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <!-- {{item.btns[0].aciton}} -->
        <div class="formItemRight" @click="item.btns[0].aciton(item)">
          <img src="../../assets/ic_arrow_down_graay.png" v-if="item.url || item.btn" class="formItemRightImg" />
          <span>{{ item.value }}</span>
        </div>
      </div>
      <!-- 年龄 -->
      <div class="formItem" v-else-if="item.pwdStrength" >
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <div class="formItemRight">
          <slot :name="item.soltName"></slot>
        </div>
      </div>
      <!-- 普通文本展示 -->
      <div class="formItem" v-else @click="item.url ? $router.push(item.url) : ''">
        <label><span v-if="item.required===2" style="color: red;">*</span>{{ item.label }}</label>
        <div class="formItemRight">
          <img src="../../assets/ic_arrow_down_graay.png" v-if="item.url" class="formItemRightImg" />
          <span>{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { footerState, footerMutations } from '@vuex/footer'
export default {
  props: {
    // 状态
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      defaultImg: require('../../assets/img_50_default_profile@3x.png')
    };
  },
  created () {
  },
  methods: {
    onSubmit () {
    },
    change (e) {
      this.$emit('getFormCont', e);
    },
    input (e) {
      this.$emit('getFormCont', e);
    }
  },
  watch: {},
  computed: {},
  components: {}
};
</script>
 <style lang="scss" scoped>
.formItem > label {
  // line-height: 44px;
}
.form {
  width: 100%;
  background: $white;
  .formItem {
    position: relative;
    display: flex;
    justify-content: space-between;
    /* align-items:center; */
    min-height: 44px;
    width: 100%;
    padding: 10px 0 0 8px;
    label {
      color: $grey;
      min-width: 90px;
    }
    .formItemRight {
      padding-right: 16px;
      min-width: 200px;
      text-align: right;
      position: relative;
      span {
        // width: calc(100% - -8px);
        // height: 44px;
        // overflow: hidden;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        display: inline-block;
        // line-height: 44px;
        text-align: right;
        white-space: break-spaces;
      }
      input {
        margin: 10px 0;
        float: right;
        // width: 50px;
        width: 100%;
        background-color: $white;
        text-align: right;
      }
      .formItemRightImg {
        margin: 2px 4px 0 4px;
        width: 16px;
        height: 16px;
        float: right;
        /* position: absolute;
            top: 50%;
            right: 16px;
            transform: translateY(-50%); */
      }
      .formItemRightTX {
        float: right;
        width: 44px;
        height: 44px;
      }
      .formItemRightTXB {
        float: right;
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
      }
    }
    .picture {
      padding-right: 16px;
      /* display: flex; */
      /* justify-content:space-around; */
      width: 210px;
      /* flex-wrap: wrap; */
      div {
        position: relative;
        overflow: hidden;
        border-radius: 5px;
        margin: 5px 2px;
        width: 60px;
        display: inline-block;
        /* flex:32%; */
        img {
          width: 100%;
        }
        span {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          text-align: center;
          opacity: 0.7;
          background: $black;
          color: $white;
          font-size: 10px;
        }
      }
    }
  }
  .dome {
    border-bottom: 0.5px solid $greydd;
  }
  .dome:nth-last-child(1) {
    border-bottom: none;
  }
}
</style>
